let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("Whd6n")).then(() => parcelRequire('6zDwd'));